/**
 * Phase I Wave 1.27 (F90) · V12 Admin Legacy Redirect.
 *
 * SPA bridge · lets V12 Admin sidebar items point to a `/admin/v2/legacy/<slug>`
 * React Router path and get `<Navigate replace>`-redirected to the classic
 * admin route *without* a full browser reload (which was the F85-class bug
 * that threw users out of the V12 shell and flushed their React auth
 * context).
 *
 * Slug map lives in `data/v12_admin_coming_soon_registry.js` so that pure-JS
 * tests can read it without pulling react-router-dom into Jest resolution.
 */
import React from "react";
import { Navigate, useParams } from "react-router-dom";

import { V12_ADMIN_LEGACY_SLUG_MAP } from "@/data/v12_admin_coming_soon_registry";

export default function V12AdminLegacyRedirect() {
    const { slug } = useParams();
    const target = V12_ADMIN_LEGACY_SLUG_MAP[slug] || "/admin";
    return <Navigate to={target} replace />;
}
